import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { Subscription } from "rxjs";
import { SrsFormElement } from "../../../abstracts/srs-form-element.abstract";
import { EdtellFileUploadConfig } from "../../../interfaces/elements/edtell-file-upload-config.interface";

@Component({
  selector: "app-edtell-file-upload",
  templateUrl: "./edtell-file-upload.component.html",
  styleUrls: ["./edtell-file-upload.component.scss"],
})
export class EdtellFileUploadComponent
  extends SrsFormElement<EdtellFileUploadConfig>
  implements OnDestroy
{
  @ViewChild("input")
  input: ElementRef;

  subscription: Subscription;

  constructor() {
    super();
  }

  onElementInit() {
    this.subscription = this.control.valueChanges.subscribe((value) => {
      // Set input element to have a null value since it is not attached to the FormControl
      if (value == null) {
        this.input.nativeElement.value = null;
        return;
      }
    });
  }

  onFileSelect(event) {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const ImageURL = reader.result.toString();

      // Split the base64 string in data and contentType
      const block = ImageURL.split(";");

      // Get the content type of the image
      let contentType = block[0].split(":")[1];

      // get the real base64 content of the file
      const realData = block[1].split(",")[1];

      // clean up MIME types
      if (
        contentType ==
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ) {
        contentType = "docx";
      }

      const asset = {
        assetName: file.name,
        assetSize: file.size,
        assetFileType: contentType,
        assetBase64: realData,
      };

      this.control.setValue(asset);
    };
  }

  get chooseFileDisabled() {
    if (this.config.disabled) {
      return this.config.disabled();
    }
    return false;
  }

  get fileName() {
    if (this.control.value == null) {
      return "No file chosen";
    }

    return this.control.value.assetName;
  }

  get accept() {
    if (Array.isArray(this.config.accept)) {
      let accept = "";
      for (const acc of this.config.accept) {
        accept += `${acc},`;
      }
      // remove last comma
      accept = accept.slice(0, -1);
      return accept;
    }

    return this.config.accept;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
